import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
export interface TablePaginationProps {
  page: number;
  pageSize: number;
  total: number;
  pageSizes?: number[];
  onPageChange: (page: number) => void;
  onPageSizeChange?: (pageSize: number) => void;
}
export function TablePagination({
  page,
  pageSize,
  total,
  pageSizes = [25, 50, 100],
  onPageChange,
  onPageSizeChange
}: TablePaginationProps) {
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  const start = page * pageSize + 1;
  const end = Math.min((page + 1) * pageSize, total);
  return <div className="px-4 py-3 border-t border-gray-100 flex flex-col sm:flex-row sm:items-center justify-between bg-gray-50 gap-3" data-id="element-8194" data-mp="5gcx01aq48xc">
      <div className="flex items-center gap-4 text-xs text-gray-500" data-id="element-8195" data-mp="ov6k76btqqm">
        {total > 0 ? <span data-id="element-8196" data-mp="3956khlz23mh6">
            Resultaat <span className="font-medium text-gray-900" data-id="element-8197" data-mp="394eucqo8agya">{start}</span>{' '}
            tot <span className="font-medium text-gray-900" data-id="element-8198" data-mp="347enwengvc6n">{end}</span> van{' '}
            <span className="font-medium text-gray-900" data-id="element-8199" data-mp="1is6ulzmz7fsj">{total}</span>
          </span> : <span data-id="element-8200" data-mp="1iq47bnd7k0ri">Geen resultaten</span>}

        {onPageSizeChange && total > 0 && <div className="flex items-center gap-2 border-l border-gray-200 pl-4" data-id="element-8201" data-mp="1npgru1glwvqx">
            <span data-id="element-8202" data-mp="1sj1krf3cezj9">Rijen per pagina:</span>
            <select value={pageSize} onChange={e => onPageSizeChange(Number(e.target.value))} className="bg-transparent font-medium text-gray-900 focus:outline-none cursor-pointer" data-id="element-8203" data-mp="1sk4avksucxy4">
            
              {pageSizes.map(size => <option key={size} value={size} data-id="element-8204" data-mp="14rw3qwlo217d">
                  {size}
                </option>)}
            </select>
          </div>}
      </div>

      <div className="flex items-center gap-2" data-id="element-8205" data-mp="18s7o08a49zib">
        <span className="text-xs text-gray-500 mr-2" data-id="element-8206" data-mp="1dslxzvva3jiz">
          Pagina {page + 1} van {totalPages}
        </span>
        <div className="flex gap-1" data-id="element-8207" data-mp="2k9fssuoodhn0">
          <button onClick={() => onPageChange(Math.max(0, page - 1))} disabled={page === 0} className="p-1.5 text-gray-500 bg-white border border-gray-200 rounded-md hover:bg-gray-50 hover:text-gray-900 disabled:opacity-50 disabled:cursor-not-allowed transition-colors" aria-label="Vorige pagina" data-id="element-8208" data-mp="2k8ef0ig9yh1l">
            
            <ChevronLeft className="w-4 h-4" data-id="element-8209" data-mp="l3wfrwfi3bc3" />
          </button>
          <button onClick={() => onPageChange(Math.min(totalPages - 1, page + 1))} disabled={page >= totalPages - 1 || total === 0} className="p-1.5 text-gray-500 bg-white border border-gray-200 rounded-md hover:bg-gray-50 hover:text-gray-900 disabled:opacity-50 disabled:cursor-not-allowed transition-colors" aria-label="Volgende pagina" data-id="element-8210" data-mp="z2w93hdykeel">
            
            <ChevronRight className="w-4 h-4" data-id="element-8211" data-mp="1ecer85nn7em" />
          </button>
        </div>
      </div>
    </div>;
}